import LoadDeviceTypes from "./LoadDeviceTypes.js";
const install = molten => {
  molten.addPlugin('BlockerHook', LoadDeviceTypes);
};
export { install };
export default {
  install
};